import { render, staticRenderFns } from "./fullCalendar.vue?vue&type=template&id=55bafe55&"
import script from "./fullCalendar.vue?vue&type=script&lang=js&"
export * from "./fullCalendar.vue?vue&type=script&lang=js&"
import style0 from "./fullCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports